import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { branch } from 'baobab-react/higher-order'
import { Image } from 'components/qstrap'
import Paper from 'components/atoms/Paper'
import Button from 'components/atoms/Button'
import Typography from 'components/atoms/Typography'
import ProfileRow from 'components/molecules/ProfileRow'

const ProfileShow = ({
  currentUser,
  onClickEdit,
}) => (
  <div>
    <div className="profile-name-header">
      <Button className="pull-right" onClick={onClickEdit}>
        Edit Profile
      </Button>
      <Typography variant="big" component="h1" className="m-b-lg">
        <Image src="/assets/img/avatar.png" className="avatar m-r-lg" />
      </Typography>
    </div>

    <>
      <Paper rounded elevation={1} className="p-a-lg m-y-md">
        <Typography variant="headline">Biodata</Typography>
        <ProfileRow label={intl.get('account.name')}>{currentUser.first_name} {currentUser.last_name}</ProfileRow>
        <ProfileRow label={intl.get('account.phone_number')}>{currentUser.phone_number}</ProfileRow>
        <ProfileRow label={intl.get('account.parent_phone_number')}>{currentUser.parent_phone_number}</ProfileRow>
      </Paper>

      <Paper rounded elevation={1} className="p-a-lg m-y-md">
        <Typography variant="headline">Informasi Sekolah</Typography>
        <ProfileRow label={intl.get('account.school')}>{currentUser.school_name}</ProfileRow>
        <ProfileRow label={intl.get('account.grade_level')}>{intl.get(`grades.${currentUser.grade_level}`)}</ProfileRow>
        <ProfileRow label={intl.get('account.school_major')}>{intl.get(`school_majors.${currentUser.school_major}`)}</ProfileRow>
      </Paper>

      <Paper rounded elevation={1} className="p-a-lg m-y-md">
        <Typography variant="headline">Akun</Typography>
        <ProfileRow label={intl.get('account.username')}>{currentUser.username}</ProfileRow>
        <ProfileRow label={intl.get('account.email')}>{currentUser.email}</ProfileRow>
      </Paper>
    </>
  </div>
)

ProfileShow.propTypes = {
  currentUser: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    phone_number: PropTypes.string,
    parent_phone_number: PropTypes.string,
    school_name: PropTypes.string,
    grade_level: PropTypes.string,
    school_major: PropTypes.string,
    username: PropTypes.string,
    email: PropTypes.string,
  }),
  onClickEdit: PropTypes.func,
}

ProfileShow.defaultProps = {
  currentUser: {},
  onClickEdit: () => {},
}

export { ProfileShow }
export default branch({
  currentUser: ['serverProps', 'currentUserProfile'],
}, ProfileShow)
